import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from './NotificationError.module.css'

export function CheckoutGroupsNotificationError() {
  const intl = useIntl()

  return (
    <div className={cn(styles.wrapper)}>
      <UnavailableContent title={intl.formatMessage({ id: 'groups_checkout_steps_error_title' })} message={intl.formatMessage({ id: 'groups_checkout_steps_error_description' })} />
    </div>
  )
}

function UnavailableContent({ title, message }: { title: string, message: string }) {
  return (
    <div className={cn(styles.contentWrapper)}>
      <Icon glyph="ExclamationInTriangle" size={32} color="#d77600" />
      <Typography variant="body-m-bold-snug">{title}</Typography>
      <Typography variant="body-s-regular-snug">{message}</Typography>
    </div>
  )
}
